<template lang="html">
  <div id="home-page">
    <!--modales  -->
    <div>
      <b-modal centered id="modal-1" hide-footer>
        <template v-slot:modal-title class="text-center title">
          {{ $t("homePage.modals.title1") }}
        </template>
        <div class="d-block text-left">
         <div class="container">
           <div class="row">
             <div class="col-md-4">
               <img class="img-fluid" src="public/images/pages/home/security.svg">
             </div>
             <div class="col-md-8">
                <p>{{ $t("homePage.modals.txt1") }}</p>
             </div>
           </div>
         </div>
        </div>
        <!-- <b-button class="mt-3" block @click="$bvModal.hide(modal.id)">Cerrar</b-button> -->
      </b-modal>
    </div>

    <div>
      <b-modal centered id="modal-2" hide-footer>
        <template v-slot:modal-title class="text-center title">
          {{ $t("homePage.modals.title2") }}
        </template>
        <div class="d-block text-left">
         <div class="container">
           <div class="row">
             <div class="col-md-4">
               <img class="img-fluid" src="public/images/pages/home/cloud.svg">
             </div>
             <div class="col-md-8">
                <p>{{ $t("homePage.modals.txt2") }}</p>
             </div>
           </div>
         </div>
        </div>
        <!-- <b-button class="mt-3" block @click="$bvModal.hide(modal.id)">Cerrar</b-button> -->
      </b-modal>
    </div>

    <div>
      <b-modal centered id="modal-3" hide-footer>
        <template v-slot:modal-title class="text-center title">
          {{ $t("homePage.modals.title3") }}
        </template>
        <div class="d-block text-left">
         <div class="container">
           <div class="row">
             <div class="col-md-4">
               <img class="img-fluid" src="public/images/pages/home/sound.svg">
             </div>
             <div class="col-md-8">
                <p>{{ $t("homePage.modals.txt3") }}</p>
             </div>
           </div>
         </div>
        </div>
        <!-- <b-button class="mt-3" block @click="$bvModal.hide(modal.id)">Cerrar</b-button> -->
      </b-modal>
    </div>

    <div>
      <b-modal centered id="modal-4" hide-footer>
        <template v-slot:modal-title class="text-center title">
          {{ $t("homePage.modals.title4") }}
        </template>
        <div class="d-block text-left">
         <div class="container">
           <div class="row">
             <div class="col-md-4">
               <img class="img-fluid" src="public/images/pages/home/resistence.svg">
             </div>
             <div class="col-md-8">
                <p>{{ $t("homePage.modals.txt4") }}</p>
             </div>
           </div>
         </div>
        </div>
        <!-- <b-button class="mt-3" block @click="$bvModal.hide(modal.id)">Cerrar</b-button> -->
      </b-modal>
    </div>
    <!--  -->

    <!-- Secciones -->
    <section class="banners-section" id="slider">
      <swiper class="d-none d-lg-block" :options="bannersOption">
        <swiper-slide v-for="(image, bhInx) in banners" :key="bhInx" v-bind:style="{'background-image': 'url('+image.imagen+')'}">
          <!-- <div class="overlay-slider"></div> -->
          <!-- <div class="slide-text text-center"><h1>{{ $t("homePage.banners.title") }}</h1></div> -->
         <!-- <img class="img-fluid" :src="image.imagen"> -->
         <img class="img-fluid" src="public/images/pages/home/banner.png">
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>

      <swiper class="d-lg-none" :options="bannersOption">
        <swiper-slide v-for="(image, bhInx) in banners_movil" :key="bhInx" v-bind:style="{'background-image': 'url('+image.imagen+')'}">
          <!-- <div class="overlay-slider"></div> -->
          <!-- <div class="slide-text text-center"><h1>{{ $t("homePage.banners.title") }}</h1></div> -->
         <!-- <img class="img-fluid" :src="image.imagen"> -->
         <img class="img-fluid" src="public/images/pages/home/banner-m.png">
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </section>

    <!-- <section class="extra-section">
      <div class="container">
        <div class="white-box">
          <div class="col-12 col-txt">
            <p class="text-center">

              {{ $t("homePage.modals.main_title") }}
            </p>
          </div>

          <div class="col-sm-6 col-lg-3 col-info">
            <a id="show-btn" @click="$bvModal.show('modal-1')" href="#">
              <div class="img">
                <div class="box">
                  <img v-bind:src="'public/images/pages/home/security.svg'" v-bind:alt="'modal-1'">
                </div>
              </div>
              <div class="info">
                <h5 class="title">{{ $t("homePage.modals.title1") }}</h5>
                <p>
                  {{ $t("homePage.modals.txt1") }}
                </p>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-lg-3 col-info">
            <a id="show-btn" @click="$bvModal.show('modal-2')" href="#">
              <div class="img">
                <div class="box">
                  <img v-bind:src="'public/images/pages/home/cloud.svg'" v-bind:alt="'modal-2'">
                </div>
              </div>
              <div class="info">
                <h5 class="title">{{ $t("homePage.modals.title2") }}</h5>
                <p>
                  {{ $t("homePage.modals.txt2") }}
                </p>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-lg-3 col-info">
            <a id="show-btn" @click="$bvModal.show('modal-3')" href="#">
              <div class="img">
                <div class="box">
                  <img v-bind:src="'public/images/pages/home/sound.svg'" v-bind:alt="'modal-3'">
                </div>
              </div>
              <div class="info">
                <h5 class="title">{{ $t("homePage.modals.title3") }}</h5>
                <p>
                  {{ $t("homePage.modals.txt3") }}
                </p>
              </div>
            </a>
          </div>
          <div class="col-sm-6 col-lg-3 col-info">
            <a id="show-btn" @click="$bvModal.show('modal-4')" href="#">
              <div class="img">
                <div class="box">
                  <img v-bind:src="'public/images/pages/home/resistence.svg'" v-bind:alt="'modal-4'">
                </div>
              </div>
              <div class="info">
                <h5 class="title">{{ $t("homePage.modals.title4") }}</h5>
                <p>
                  {{ $t("homePage.modals.txt4") }}
                </p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section> -->

    <!-- <section id="articles">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <h2 class="text-center common-title mt-5 mb-4">{{ $t("homePage.titles.articles") }}</h2>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <swiper class="swiper-arrow-blue swiper-article" :options="articlesOption">
              <swiper-slide v-for="(article, arInx) in articles" :key="arInx" class="mb-5">
                <router-link :to="'/articulo/'+article.id">
                  <div class="article-box">
                    <div class="image-cage" v-bind:style="{ backgroundImage: 'url('+article.image+')'} ">
                      <img class="img-fluid" src="public/images/shared/article.png">
                    </div>
                    <div class="article-title-box">
                      <div class="title-container">
                        <h5 class="text-center">{{ article.name }}</h5>
                      </div>
                    </div>
                  </div>
                </router-link>
              </swiper-slide>

              <div class="swiper-pagination"  slot="pagination"></div>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section> -->

    <section class="products-section">
      <div class="container oversized-container content">
        <h2 class="common-title">{{ $t("homePage.titles.products") }}</h2>
        <div class="row">
          <div class="col-md-12">
            <swiper :options="productosOption">
              <swiper-slide class="col-product-sample-v2" v-for="(product, pjInx) in products" :key="'pjInx-'+pjInx">
                <router-link class="pj-link" :to="'/productos/categoria/'+product.id">
                  <div class="box-img">
                    <img class="placed-backg" src="public/images/shared/article.png" v-bind:style="{ backgroundImage: 'url('+product.image+')' }">
                  </div>
                  <div class="box-info">
                    <h5>{{ product.name }}</h5>
                  </div>
                </router-link>
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>

    <section class="projects-section">
      <div class="container oversized-container content">
        <h2 class="common-title">{{ $t("homePage.titles.projects") }}</h2>

        <div class="box-carousel">
          <swiper :options="projectsOption" class="projectSlider">
            <swiper-slide class="col-project-sample" v-for="(project, pjInx) in projects" :key="pjInx" >
              <router-link class="pj-link" :to="'/proyectos/categoria/'+project.id">

                <div class="placed-backg box-img" v-bind:style="{ backgroundImage: 'url('+project.image+')' }">
                  <img src="public/images/pages/home/p-empty.png">
                </div>
                <div class="box-info">
                    <h5>{{ project.name }}</h5>
                </div>
              </router-link>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
    </section>

    <section class="suppliers-section">
      <h2 class="common-title">{{ $t("homePage.titles.providers") }}</h2><br>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <swiper class="swiper" :options="proveedoresOption">
              <swiper-slide v-for="(proveedor, pjInx) in proveedores" :key="pjInx">
                <div class="box-img">
                  <div class="inside">
                    <img :src="proveedor.image">
                  </div>
                </div>
              </swiper-slide>
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </div>
        </div>
      </div>
    </section>
    <!--  -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [
        /*{ imagen: 'public/images/pages/home/banner-1.jpg' },
        { imagen: 'public/images/pages/home/banner-2.jpg' },*/
      ],
      banners_movil: [
        /*{ imagen: 'public/images/pages/home/banner-1-m.jpg' },
        { imagen: 'public/images/pages/home/banner-2-m.jpg' },*/
      ],

      projects: [
        /*{ id: 1, image: 'public/images/pages/home/project-1.jpg', name: 'Hoteles', },
        { id: 2, image: 'public/images/pages/home/project-2.jpg', name: 'Edificios', },
        { id: 3, image: 'public/images/pages/home/project-3.jpg', name: 'Residencias', },*/
      ],

      products: [
        /*{ id: 1, name: 'Ventanas', image: 'public/images/pages/products/product-1.jpg' },
        { id: 2, name: 'Canceles de Baño', image: 'public/images/pages/products/product-2.jpg' },
        { id: 3, name: 'Mosquiteros', image: 'public/images/pages/products/product-3.jpg' },
        { id: 4, name: 'Persinas Enrollables', image: 'public/images/pages/products/product-4.jpg' },
        { id: 5, name: 'Canceles de Baño', image: 'public/images/pages/products/product-5.jpg' },
        { id: 6, name: 'Vidrios', image: 'public/images/pages/products/product-5.jpg' },*/
      ],

      /*benefits: [
        { imageUrl: 'public/images/pages/home/security.svg', title: 'Seguridad', description: 'Dureza de perfiles y herrajes importados de Alemania.', modalNum: 'modal-1'},
        { imageUrl: 'public/images/pages/home/cloud.svg', title: 'Aislamiento Térmico', description: 'Ahorro importantes de energia de calefacción y aire acondicionado.', modalNum: 'modal-2'},
        { imageUrl: 'public/images/pages/home/sound.svg', title: 'Aislamiento Acústico', description: 'Disminución de ruido real.', modalNum: 'modal-3' },
        { imageUrl: 'public/images/pages/home/resistence.svg', title: 'Resistencia', description: 'PVC con gran protección para cualquier eventualidad.', modalNum: 'modal-4' },
      ],*/

      proveedores: [
        /* { image: 'public/images/pages/suppliers/aluplast.jpg', pName: 'Distribuidor 1' },
         { image: 'public/images/pages/suppliers/siegenia.jpg', pName: 'Distribuidor 2' },
         { image: 'public/images/pages/suppliers/gu.jpg', pName: 'Distribuidor 3' },
         { image: 'public/images/pages/suppliers/tecesa_logo.jpg', pName: 'Distribuidor 4' },
         { image: 'public/images/pages/suppliers/hoppe.jpg', pName: 'Distribuidor 4' },
         { image: 'public/images/pages/suppliers/cristacurva.jpg', pName: 'Distribuidor 4' },*/
      ],

      /*modals: [
          {id: 'modal-1', title: 'Seguridad', text: 'La dureza de los perfiles junto con los herrajes importados de Alemania, proporcionan una seguridad muy por encima de cualquier otro tipo de ventana fabricado con otro material.', image: 'public/images/pages/home/seguridad.jpg',},
          {id: 'modal-2', title: 'Aislamiento Térmico', text: 'Cualidad que crea no solamente confort en las habitaciones, sino que genera ahorros muy importantes de energía en las calefacciones y aires acondicionados.', image:  'public/images/pages/home/aislamiento-ter.jpg'},
          {id: 'modal-3', title: 'Aislamiento Acústico', text: 'Una de las principales cualidades que brindan nuestras ventanas ya que se logra  una disminución del ruido por debajo de los niveles recomendados para dormir.', image: 'public/images/pages/home/aislamiento.jpg',},
          {id: 'modal-4', title: 'Resistencia', text: 'La alta resistencia al fuego de los perfiles de PVC proporciona una protección extra contra cualquier eventualidad.', image: 'public/images/pages/home/resistencia.jpg',}
      ],*/

      articles: [
       /* { id: 1, image: 'public/images/pages/home/article1.jpg', name: 'Ventajas de ventanas de PVC', },
        { id: 1, image: 'public/images/pages/home/article2.jpg', name: 'Ventajas del PVC Aluplast',},
        { id: 1, image: 'public/images/pages/home/article3.jpg', name: 'Consejos como escoger PVC correcto',},
        { id: 1, image: 'public/images/pages/home/article4.jpg', name: '¿Cuanto ahorro con las ventanas de PVC?',},
        { id: 1, image: 'public/images/pages/home/article5.jpg', name: '¿Que beneficios trae las ventanas de PVC para medio ambiente ?',},*/
      ],

      swiperOption: {
        pagination: {
          el: '.swiper-pagination'
        },
        // some swiper options...
      },

      // == Carrusels options ==
      bannersOption: {
        speed:800,
        loop: true,

        navigation: {
         nextEl: '.swiper-button-next',
         prevEl: '.swiper-button-prev'
       },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
      },
      projectsOption: {
        slidesPerView: 3,
        spaceBetween: 26,

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          992: {
            slidesPerView: 3,
            spaceBetween: 26
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 25
          },
          1: {
            slidesPerView: 1,
            spaceBetween: 30
          },
        }
      },

      productosOption: {
        slidesPerView: 4,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        breakpoints: {
          1500: {
            slidesPerView: 4,
            spaceBetween: 20
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      // == Carrusels options ==
      proveedoresOption: {
        speed:2500,
        loop:false,
        slidesPerView: 5,
        spaceBetween: 30,
        autoplay: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1699: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 3,
          },
          992: {
            slidesPerView: 2,
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      articlesOption: {
        loop:true,
        slidesPerView: 3,
        spaceBetween: 30,
        // autoplay: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1200: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          768: {
            slidesPerView: 2
          },
          1: {
            slidesPerView: 1
          },
        }
      },

      }
    },
    watch: {
      '$i18n.locale': function (newVal, oldVal) {
        if(this.$root.subDomain() == false){ // Solo local
          this.getArticles();

        }
      }
    },
    methods: {
      showModal() {
      this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
      },
      getBanners: function(){
        axios.get(tools.url('/bannersFront')).then(
          ({data}) =>{
            this.banners=data;
            var navegador=navigator.userAgent; //busco el "userAgent" del usuario.
            //lista de palabras del "userAgent" en los móviles
            var moviles=["Mobile","iPhone","iPod","BlackBerry","Opera Mini","Sony","MOT","Nokia","samsung"];
            var detector=0; //Variable que detectará si se usa un móvil
            for (var i in moviles) { //comprobar en la lista ...
               //si el método "indexOf" no devuelve -1, indica que la palabra está en el "userAgent"
                var compruebo=navegador.indexOf(moviles[i]);
               if (compruebo>-1) {
                  detector=1; //Si es un móvil, cambio el valor del detector
                  }
               }
            if (detector==1)
              this.banners = this.banners.movil;
            else
              this.banners = this.banners.pc;
          });
      },
      getCategoriesProducts: function(){
        axios.get(tools.url('/categoriesFrontProducts')).then(
          ({data}) =>{
            this.products=data;
          });
      },
      getCategoriesProjects: function(){
        axios.get(tools.url('/categoriesFrontProjects')).then(
          ({data}) =>{
            this.projects=data;
          });
      },
      getArticles: function(){
        axios.get(tools.url('/articlesFront')).then(
          ({data}) =>{
            this.articles=data[this.$i18n.locale];
          });
      },
      getProviders: function(){
        axios.get(tools.url('/providersFront')).then(
          ({data}) =>{
            this.proveedores=data;
          });
      },

    },
    mounted() {
       this.getBanners();
       this.getCategoriesProducts();
       this.getCategoriesProjects();
       //this.getArticles();
       this.getProviders();
      /*setTimeout(() => {
        this.banners.push('/4.jpg')
        console.log('banners update')
      }, 3000)
      console.log(
        'This is current swiper instance object', this.mySwiper,
        'It will slideTo banners 3')
      this.mySwiper.slideTo(3, 1000, false)*/



      /**/
    }
  }

</script>

<style>
  /* Media Queries Responsive Design */
@media screen and (max-width: 980px) {
.slide-text {
  top: 48% !important;
}
.slide-text h1 {
    font-size: 2em !important;
    line-height: 44px !important;
}
}
</style>
